<template>
  <notes v-if="!loading" @reloadInfo='reloadInfo' @returnToOverview='returnToOverview'/>
</template>

<script>
import Notes from '@/components/Notes';
import { mapState } from 'vuex';
import ACTIONS from '@/store/storeActions';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

export default {
  name: 'NotesPage',
  components: {
    Notes
  },
  computed: {
    ...mapState({
      currentExerciseId: (state) => state.run.currentExerciseId,
      openExerciseId: (state) => state.run.candidate.selectedExerciseId,
      exercises: (state) => state.run.exercises,
      timetable: (state) => state.run.timetable,
    }),
    getTimetableForExercise() {
      const times = this.timetable.filter( (x) => x.exerciseId === this.currentExerciseId);
      times.sort((a, b) => dayjs(a.startTime).isSameOrBefore(dayjs(b.startTime)))
      return {
        overallStart: times[0].startTime,
        overallEnd: times[times.length - 1].endTime
      }
    }
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    reloadInfo() {
      const self = this;
      this.loading = true;
      self.$api.run.getCandidateStatus().finally(() => {
        self.loading = false;
      });
    },
    returnToOverview() {
      const self = this;
      self.$router.push('overview');
    }
  },
  mounted() {
    if (!this.currentExerciseId) {
      this.$router.push('overview');
      this.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.$i18n.t('Errors.noExerciseSelected'), color: 'error' } );
    }
    this.loading = false;
  }
}
</script>

<style scoped>

</style>
